import { EmpathyXConfig } from '../../models';
import { DEFAULT_BANNERS_CONFIG as banners } from './components/banners.config';
import { DEFAULT_CLOSE_CONFIG as close } from './components/close.config';
import { DEFAULT_DISCOVERY_WALL_CONFIG as discoveryWall } from './components/discovery-wall.config';
import { DEFAULT_EMPATHIZE_CONFIG as empathize } from './components/empathize.config';
import { DEFAULT_EMPTY_CONFIG as emptySearch } from './components/empty-search.config';
import { DEFAULT_FACETS_CONFIG as facets } from './components/facets.config';
import { DEFAULT_FALLBACK_FILTERS_CONFIG as fallbackFilters } from './components/fallback-filters.config';
import { DEFAULT_HISTORY_CONFIG as history } from './components/history.config';
import { DEFAULT_IDENTIFIER_SUGGESTIONS_CONFIG as identifierSuggestions } from './components/identifier-suggestions.config';
import { DEFAULT_NEXT_QUERIES_SUGGESTIONS_CONFIG as nextQueriesSuggestions } from './components/next-queries-suggestions.config';
import { DEFAULT_NEXT_QUERIES_CONFIG as nextQueries } from './components/next-queries.config';
import { DEFAULT_NO_RESULTS_CONFIG as noResults } from './components/no-results.config';
import { DEFAULT_OPEN_CONFIG as open } from './components/open.config';
import { DEFAULT_PARTIALS_CONFIG as partialResults } from './components/partials.config';
import { DEFAULT_POPULAR_SEARCHES_CONFIG as popularSearches } from './components/popular-searches.config';
import { DEFAULT_PRE_FACETS_CONFIG as preFacets } from './components/pre-facets.config';
import { DEFAULT_RECOMMENDATIONS_CONFIG as recommendations } from './components/recommendations.config';
import { DEFAULT_REDIRECTION_CONFIG as redirection } from './components/redirection-config';
import { DEFAULT_REDIRECTIONS_SUGGESTIONS_CONFIG as redirectionsSuggestions } from './components/redirections-suggestions.config';
import { DEFAULT_RELATED_TAGS_CONFIG as relatedTags } from './components/related-tags.config';
import { DEFAULT_RESULTS_GRID_CONFIG as resultsGrid } from './components/results-grid.config';
import { DEFAULT_RESULTS_NUMBER_CONFIG as resultsNumber } from './components/results-number.config';
import { DEFAULT_RESULTS_SUGGESTIONS_CONFIG as resultsSuggestions } from './components/results-suggestions.config';
import { DEFAULT_RESULTS_CONFIG as results } from './components/results.config';
import { DEFAULT_SCROLL_TO_TOP_CONFIG as scrollToTop } from './components/scroll-to-top.config';
import { DEFAULT_SCROLL_CONFIG as scroll } from './components/scroll.config';
import { DEFAULT_SEARCH_BOX_CONFIG as searchBox } from './components/search-box.config';
import { DEFAULT_SORT_CONFIG as sort } from './components/sort.config';
import { DEFAULT_SPELLCHECK_CONFIG as spellcheck } from './components/spellcheck.config';
import { DEFAULT_TERM_SUGGESTIONS_CONFIG as termSuggestions } from './components/term-suggestions.config';
import { DEFAULT_WINDOW_EVENT_BINDER_CONFIG as windowEventBinder } from './components/window-event-binder.config';
import { DEFAULT_CORE_CONFIG as core } from './core.config';
import { DEFAULT_LOCALE_CONFIG as locale } from './locale.config';
import { DEFAULT_CONTAINER_SERVICES as services } from './services-container.config';
import { DEFAULT_TRACK_ADD_TO_CART_CONFIG as trackAddToCart } from './tracking/track-add-to-cart.config';
import { DEFAULT_TRACK_CHECKOUT_CONFIG as trackCheckout } from './tracking/track-checkout.config';
import { DEFAULT_TRACK_CLICK_CONFIG as trackClick } from './tracking/track-click.config';
import { DEFAULT_TRACK_QUERY_CONFIG as trackQuery } from './tracking/track-query.config';
import { DEFAULT_URL_CONFIG as url } from './url.config';
import { DEFAULT_USER_SERVICE_STORAGE_CONFIG as userServiceStorage } from './user-service.config';

export * from './core.config';
export * from './components/empathize.config';

export const DEFAULT_EMPATHY_X_CONFIG: EmpathyXConfig = {
  container: {
    services
  },
  core,
  locale,
  banners,
  close,
  discoveryWall,
  empathize,
  emptySearch,
  facets,
  fallbackFilters,
  history,
  scroll,
  identifierSuggestions,
  nextQueriesSuggestions,
  nextQueries,
  noResults,
  open,
  partialResults,
  popularSearches,
  preFacets,
  recommendations,
  redirection,
  redirectionsSuggestions,
  relatedTags,
  results,
  resultsGrid,
  resultsNumber,
  resultsSuggestions,
  scrollToTop,
  searchBox,
  sort,
  spellcheck,
  termSuggestions,
  tracking: {
    query: trackQuery,
    click: trackClick,
    addToCart: trackAddToCart,
    checkout: trackCheckout
  },
  url,
  userServiceStorage: userServiceStorage,
  windowEventBinder
};
